import React, { useEffect } from "react";
import { MDBDataTableV5 } from "mdbreact";
import { Button, TableContainer } from "../../../styles";
import { ICON_PLUS } from "../../../utils/icons";
import MiniLoader from "../../../utils/MIniLoader";
import { useCustomerContext } from "../../../context/customer_context";
import CustomTable from "../../../utils/CustomTable";

export default function AllCustomers() {

      const {
            customerLoading, getCustomerData, allCustomers
      } = useCustomerContext();

      useEffect(() => {
            const customers = allCustomers?.map(({ customer_name, customer_mail, customer_phone, dateTime, }, i) => {
                  return (
                        {
                              sn: 1 + i,
                              customer_name,
                              customer_phone,
                              customer_mail,
                              dateTime,
                        }
                  );
            });

            setDatatable({
                  ...datatable,

                  rows:
                        customers
            });
      }, [allCustomers]);

      useEffect(() => {
            getCustomerData();
      }, []);


      const [datatable, setDatatable] = React.useState({
            columns: [
                  {
                        label: "S/N",
                        field: "sn",
                        width: 150,
                  },
                  {
                        label: "Date Added",
                        field: "dateTime",
                        width: 200,
                  },
                  {
                        label: "Name",
                        field: "customer_name",
                        width: 270,
                  },
                  {
                        label: "Phone",
                        field: "customer_phone",
                        width: 270,
                  },
                  {
                        label: "Email",
                        field: "customer_mail",
                        width: 270,
                  },

            ],
            rows: []
      });


      return (
            <>

                  <div className="">

                        <CustomTable
                              tableTitle={"All Customers"}
                              loading={customerLoading}
                              getData={getCustomerData}
                              datatable={datatable}
                        />

                  </div>

            </>

      );
}
